import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_Operators = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      title="Operators, Operator Precedence and Expressions"
      videos={[
        "https://www.youtube.com/embed/E1_Gg6dURwk", // Operators in C - Part 1
        "https://www.youtube.com/embed/hOLAoo2p7gM", // Operator Precedence and Associativity
      ]}
      takeaways={[
        { text: "Focus on pre-increment, post-increment, pre-decrement, and post-decrement operations and understand how they work." },
        { text: "Remember the operator precedence table and associativity of operators." },
        { text: "Learn how to evaluate expressions using precedence and associativity rules." },
        { text: "Know the different types of operators in C." },
      ]}
      questions={[
        "Evaluate expressions using increment, decrement, and shift operators.",
        "Explain the theory of operators and operator precedence.",
      ]}
      exampleVideos={[]} // Add if you have any practice or example videos
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default OOPS_M1_Operators;
